import React, {FC, useCallback, useEffect, useRef, useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
// import "moment/locale/en-gb"; // English (United Kingdom)
// import "moment/locale/en-ca"; // English (Canada)
// import "moment/locale/en-au"; // English (Australia)
// import "moment/locale/en-nz"; // English (New Zealand)
// import "moment/locale/en-in"; // English (India)
import "moment/locale/fr";    // French (default)
// import "moment/locale/fr-ca"; // French (Canada)
// import "moment/locale/fr-ch"; // French (Switzerland)
import "moment/locale/de";    // German (default)
// import "moment/locale/de-at"; // German (Austria)
// import "moment/locale/de-ch"; // German (Switzerland)
import "moment/locale/es";    // Spanish (default)
// import "moment/locale/es-mx"; // Spanish (Mexico)
import "moment/locale/it";    // Italian (default)
// import "moment/locale/it-ch"; // Italian (Switzerland)
import "moment/locale/ja";    // Japanese
import "moment/locale/ko";    // Korean
import "moment/locale/zh-cn"; // Chinese (Simplified)
import "moment/locale/zh-tw"; // Chinese (Traditional)
import "moment/locale/ru";    // Russian
import "moment/locale/ar";    // Arabic
import "moment/locale/id";    // Indonesian
import Swal from 'sweetalert2'
import {v4 as uuidv4} from 'uuid'
import useAccessToken from '../../../hooks/AccessToken'
import {useDataTableStore} from '../../../stores/DataTableStore'
import useSWR, {mutate} from 'swr'
import {useIntl} from 'react-intl'
import axios from 'axios'
import {Progress} from '../../../interfaces/Progress'
import {SelectOption} from '../../../interfaces/SelectOption'
import {usePipelineStore} from '../../../stores/PipelineStore'
import ReactQuill from 'react-quill'
import {shallowEqual, useSelector} from 'react-redux'
import {useCustomeStore} from '../../../stores/CustomeStore'
import {UserModel} from '../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../setup'
import {useSettingsStore} from '../../../stores/SettingsStore'
import {
  ColumnInvoices,
  ColumnType,
  InvoiceConfig,
  InvoicePages,
  InvoiceMultiPageSetting,
} from '../../../interfaces/Invoices'
import {nanoid} from 'nanoid'
import {Modal, Spinner} from 'react-bootstrap'
import {getInvoiceDetail,  getSelectedMultiPipelines, setCustomFieldVariables} from '../../Invoices/InvoiceUtils'
import {InvoicePreview} from '../../Invoices/PreviewInvoice'
import { LoadingInvoiceContent } from '../../Invoices/InvoiceComponentParts'
import { Pipeline } from '../../../interfaces'
import { RecentChatHistoryPipeline } from '../../../interfaces/Chat/RecentChatHistory'

export type InvoiceRenderContext = 'preview' | 'send-whatsapp' | 'resend-whatsapp' // 'download'
export type InvoiceRouterContext = 'add-log' | 'log' | 'list-invoice'

interface InvoiceAttachmentsProps {
  context: InvoiceRenderContext 
  routerContext: InvoiceRouterContext
  lead: Pipeline | RecentChatHistoryPipeline
  invoice: InvoiceMultiPageSetting
  showInvoiceModal?: boolean
  handleInvoiceModalClose?: (value: boolean) => void
  closeModalRef?: React.RefObject<HTMLButtonElement>
}

export const InvoiceAttachments: FC<InvoiceAttachmentsProps> = ({
  context,
  routerContext,
  lead,
  invoice,
  showInvoiceModal,
  handleInvoiceModalClose,
  closeModalRef,
}) => {
  const API_URL = process.env.REACT_APP_API_URL

  const {multiPipelines} = usePipelineStore()
  const {settings} = useSettingsStore()
  const token = useAccessToken()

  const [multiPages, setMultiPages] = useState<InvoicePages[] | null>(null) // TODO: MAIN

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const modalRef = useRef<HTMLDivElement | null>(null)

  const [pipeProgress, setPipeProgress] = useState<any>([]) // TODO: (UNUSED)
  const [dataProgress, setDataProgress] = useState<SelectOption[]>([]) // TODO: (UNUSED)

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const {companyId} = useCustomeStore()

  const [stepForm, setStepForm] = useState<number>(0)  // TODO: (UNUSED)
  const [column, setColumn] = useState<any[]>([])

  const intl = useIntl()

  const formSchema = Yup.object().shape({
    id: Yup.string().required('ID is required'),
    name: Yup.string().required(
      intl.formatMessage({id: 'FORM.VALIDATION.CHOOSE'}, {title: 'Nama'})
    ),
    caption: Yup.string(),
    progressId: Yup.string()
      .uuid('Invalid progress id')
      .nullable() // Memungkinkan nilai null
      .required(intl.formatMessage({id: 'FORM.VALIDATION.CHOOSE'}, {title: 'Progress'})),
    leadTemplateId: Yup.string().required(
      intl.formatMessage({id: 'FORM.VALIDATION.CHOOSE'}, {title: 'Pipe'})
    ),
    format: Yup.string(),
    // backgroundImage: Yup.mixed()
    //   .test(
    //     'fileRequired',
    //     intl.formatMessage({id: 'FORM.VALIDATION.NO_FILE'}),
    //     (value) => value && value.size > 0
    //   )
    //   .test(
    //     'fileSize',
    //     intl.formatMessage({id: 'FORM.VALIDATION.MAX_SIZE'}, {size: '5MB'}),
    //     (value) => value && value.size <= 5242880
    //   )
    //   .test(
    //     'fileType',
    //     intl.formatMessage({id: 'FORM.VALIDATION.FORMAT_FILE'}, {format: 'jpg, jpeg, png'}),
    //     (value) => value && ['image/jpg', 'image/jpeg', 'image/png'].includes(value.type)
    //   ),
  })

  const formik = useFormik({
    initialValues: {
      id: '',
      name: '',
      caption: '',
      progressId: '',
      leadTemplateId: 'd2d41893-ecf5-4322-bc8d-35282f22705f',
      // leadTemplateId: invoice.leadTemplate!.id,
      format: 'pdf',
      backgroundImage: [],
    },
    validateOnChange: true,
    enableReinitialize: true,
    validationSchema: formSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      // ----- Set Form
      if (stepForm === 0) {
        return void 0
        // setStepForm(1)
      }
    },
  })

  const fetcher = (url: string) =>
    axios
      .get(url, {
        headers: {
          'X-Auth-token': token,
        },
      })
      .then((res) => res.data.data)

  const {
    data: progresses = [],
    error,
    isLoading: isLoadingProgress,
  } = useSWR(`${API_URL}lead_progresses`, fetcher)

  useEffect(() => {
    if (!isLoadingProgress) {
      const data = progresses.map((progress: Progress) => ({
        value: progress.id,
        label: progress.name,
        isRequiredUpdateProductHpp: progress.isRequiredUpdateProductHpp,
        isRequiredAttachment: progress.isRequiredAttachment,
      }))
      setDataProgress(data)
    }
  }, [progresses])

  // ---------------------- Set Custom Fields Variables ----------------------
  useEffect(() => {
    if (multiPipelines.length > 0) {
      getSelectedMultiPipelines(token, multiPipelines, setPipeProgress)
    }
    setCustomFieldVariables(intl, user, settings, companyId, multiPipelines, formik, setColumn)
  }, [multiPipelines, formik.values.leadTemplateId])

  useEffect(() => {
    if (invoice) {
    // if (invoice && column.length > 0) {
      setIsLoading(true)
      getInvoiceDetail('preview', invoice, token, formik, column, setMultiPages, setIsLoading)
    }
  }, [invoice, column])

  // ---------------------- Debug ----------------------

  // useEffect(() => {
  //   console.log('multiPages', multiPages)
  // }, [multiPages])

  // useEffect(() => {
  //   console.log('stepForm',stepForm)
  // }, [stepForm]);

  // useEffect(() => {
  //   console.log('formik.values', formik.values)
  // }, [formik.values]);

  // useEffect(() => {
  //   console.log('formik.errors',formik.errors)
  // }, [formik.errors]);

  return (
    <div>
      {(context === 'preview' || context === 'resend-whatsapp') && (routerContext === 'log' || routerContext === 'list-invoice') ? (
        <Modal
          ref={modalRef}
          show={showInvoiceModal}
          onHide={() =>
            handleInvoiceModalClose && handleInvoiceModalClose(false)
          }
          centered
          backdrop='static'
          keyboard={false}
          size='xl'
          // fullscreen="xl-down"
          // style={{width: '1000px'}}
        >
          <Modal.Header
            closeButton
            // onHide={handleInvoiceModalClose}
          >
            <Modal.Title>{intl.formatMessage({id: 'INVOICE.PANEL.LOG_PREVIEW_PAGES'})}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{padding: '0px', minHeight: '400px'}}>
            {isLoading ? (
              <LoadingInvoiceContent />
            ) : (
              <ShowInvoicePreview
                routerContext={routerContext}
                context={context}
                lead={lead}
                invoice={invoice}
                isLoading={isLoading}
                formik={formik}
                multiPages={multiPages}
                stepForm={stepForm}
                column={column}
                extractPages={false}
                setMultiPages={setMultiPages}
                handleInvoiceModalClose={handleInvoiceModalClose}
                closeModalRef={closeModalRef}
              />
            )}
          </Modal.Body>
          {/* <Modal.Footer>
						<Button onClick={handleModalClose}>Close</Button>
					</Modal.Footer> */}
        </Modal>
      ) : context === 'send-whatsapp' && routerContext === 'add-log' ? (
            <>
              {isLoading ? (
                <LoadingInvoiceContent />
              ) : (
                <ShowInvoicePreview
                  routerContext={routerContext}
                  context={context}
                  lead={lead}
                  invoice={invoice}
                  isLoading={isLoading}
                  formik={formik}
                  multiPages={multiPages}
                  stepForm={stepForm}
                  column={column}
                  extractPages={false}
                  setMultiPages={setMultiPages}
                  handleInvoiceModalClose={handleInvoiceModalClose}
                  closeModalRef={closeModalRef}
                />
              )}
            </>
      ) : (
        <LoadingInvoiceContent />
      )}
    </div>
  )
}

const ShowInvoicePreview = ({
  routerContext,
  context,
  isLoading,
  formik,
  multiPages,
  stepForm,
  column,
  extractPages,
  setMultiPages,
  invoice,
  lead,
  handleInvoiceModalClose,
  closeModalRef,
}: {
  routerContext: InvoiceRouterContext
  context: InvoiceRenderContext
  isLoading: boolean
  formik: any
  multiPages: InvoicePages[] | null
  stepForm: number
  column: any[]
  extractPages: boolean
  setMultiPages: React.Dispatch<React.SetStateAction<InvoicePages[] | null>>
  invoice: InvoiceMultiPageSetting
  lead: Pipeline | RecentChatHistoryPipeline
  handleInvoiceModalClose?: (value: boolean) => void
  closeModalRef?: React.RefObject<HTMLButtonElement>
}) => {
  return (
    <div
      className='stepper stepper-links d-flex flex-column first m-0'
      id='kt_create_account_stepper'
      data-kt-stepper='true'
    >
      {isLoading ? (
        <div style={{height: '500px'}} className='d-flex align-items-center justify-content-center'>
          Loading...
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit} noValidate>
          {multiPages && multiPages.length > 0 ? (
            <>
              <div
                className={`${stepForm === 0 ? 'current' : 'pending'} `}
                data-kt-stepper-element='content'
              >
                <InvoicePreview
                  routerContext='pipeline'
                  invoice={invoice}
                  column={column}
                  multiPages={multiPages}
                  extractPages={extractPages}
                  setMultiPages={setMultiPages}
                  format={'pdf'}
                  showDownloadBtn={true}
                  showFormButton={(context === 'send-whatsapp' || context === 'resend-whatsapp') ? true : false}
                  handleInvoiceModalClose={handleInvoiceModalClose}
                  closeModalRef={closeModalRef}
                />
              </div>
            </>
          ): 
          <div style={{height: '500px'}} className='d-flex align-items-center justify-content-center'>
            Loading Data...
          </div>}
          {/* <InvoiceSteps
                stepForm={stepForm}
                multiPages={multiPages}
                modalBtnLoading={modalBtnLoading}
                handleBack={() => {
                    if (stepForm > 0) {
                        setIsBack(true)
                        setStepForm(stepForm - 1) // Kurangi step
                    }
                }}
                setExtractPages={setExtractPages}
            /> */}
        </form>
      )}
    </div>
  )
}
